import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import PolaroidPhoto from "./PolaroidPhoto";
import roadMapPhotos from "../../data/roadMapPhotos";
import { PHOTOS_BEFORE_FOLD } from "../../data/roadMapData";

// Photo collage. Each picture is its own element (no pre-baked collage image),
// laid out on a responsive grid: four columns on desktop, two on small screens
// and one on the narrowest phones. Only the first batch is rendered up front so
// the page stays light; the rest is one click away.
const PolaroidGallery = () => {
  const { t } = useTranslation("roadmap");
  const [expanded, setExpanded] = useState(false);

  const visible = expanded
    ? roadMapPhotos
    : roadMapPhotos.slice(0, PHOTOS_BEFORE_FOLD);
  const hiddenCount = roadMapPhotos.length - visible.length;

  return (
    <div className="rm-gallery">
      <div className="rm-gallery__grid">
        {visible.map((photo, index) => (
          <div
            className={`rm-gallery__item${
              photo.featured ? " rm-gallery__item--featured" : ""
            }`}
            key={photo.id}
          >
            <PolaroidPhoto
              src={photo.src}
              alt={
                photo.altKey
                  ? t(`photos.${photo.altKey}`)
                  : t("photos.generic", { name: t("institutionName") })
              }
              year={photo.year}
              caption={photo.captionKey ? t(`captions.${photo.captionKey}`) : undefined}
              rotation={photo.rotation}
              featured={photo.featured}
              priority={index < 2}
            />
          </div>
        ))}
      </div>

      {hiddenCount > 0 && (
        <div className="rm-gallery__more">
          <button
            type="button"
            className="theme-btn"
            onClick={() => setExpanded(true)}
          >
            {t("gallery.showMore", { count: hiddenCount })}
          </button>
        </div>
      )}
    </div>
  );
};

export default PolaroidGallery;
